module.exports = __webpack_public_path__ + "img/wasp.acf7a02e.png";